import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { manageServicesAvailabilityShape } from 'constants/propTypes';
import { bem, classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';
import When from 'components/When';
import { TooltipToggle, TooltipContent } from 'components/Tooltip';
import { ICONS } from 'constants/icons';
import { AvailabilitySummary } from '../../Components/AvailabilitySummary';
import { messages } from '../Practitioners.messages';
import './PractitionersListItem.scss';

const { block, element } = bem('practitioners-list-item');

const PractitionersListItem = ({ id, firstName, lastName, recurrence, selectedPractitionerId, goToItem, services }) => {
  const isSelected = id === selectedPractitionerId;
  const fullName = lastName ? `${firstName} ${lastName}` : firstName;
  const servicesLength = services?.length;
  const isDisabled = !servicesLength;

  return (
    <div className={withMods(block(), { isDisabled })}>
      {isSelected && <span className={element('selected-marker')} />}
      <button type="button" className={element('button')} onClick={goToItem}>
        <div className={element('box', 'grid grid--flush')}>
          <AvailabilitySummary name={fullName} recurrence={recurrence} />
          <When predicate={isDisabled}>
            <TooltipToggle name="service-disabled-tooltip">
              <Isvg src={ICONS.infoYellow} title="white exclamation mark on yellow background" />
            </TooltipToggle>
            <TooltipContent name="service-disabled-tooltip">
              <Message message={messages.list.disabledTooltip} />
            </TooltipContent>
          </When>
        </div>

        <When predicate={!!servicesLength}>
          <Message
            as="div"
            className="text--ui70"
            message={messages.list.servicesCount}
            values={{ servicesCount: servicesLength }}
          />
        </When>
      </button>
    </div>
  );
};

PractitionersListItem.propTypes = {
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  selectedPractitionerId: PropTypes.number,
  goToItem: PropTypes.func,
  recurrence: manageServicesAvailabilityShape.recurrence,
  services: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, duration: PropTypes.number, name: PropTypes.string })
  ),
};

export default PractitionersListItem;
